import { useCustomerFeatureFlag } from '@m/hooks/data/featureFlags';
import { FlagOptions } from '@m/services/experimentation/FeatureFlagService';
import { useSelectedEnterpriseId } from 'apps/portal/hooks/useSelectedEnterpriseId';

/**
 * Portal feature flag hook. Wraps `useCustomerFeatureFlag` and injects the currently selected
 * enterprise id so callers don't have to pass it. Uses the customer endpoint because it
 * returns a plain boolean enabled/disabled status (the admin endpoint returns a full settings
 * object instead).
 */
export const usePortalFeatureFlag = (name: string, options?: Omit<FlagOptions, 'enterpriseId'>) => {
  const enterpriseId = useSelectedEnterpriseId();

  return useCustomerFeatureFlag(name, { ...options, enterpriseId });
};
